import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";
import Swal from "sweetalert2";
import { Md5 } from "ts-md5/dist/md5";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { UtilityService } from "src/app/services/utility.service";
import { SharedService } from "src/app/services/shared.service";
import * as $ from "jquery";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

@Component({
  selector: "app-loggedsamples",
  templateUrl: "./loggedsamples.component.html",
  styleUrls: ["./loggedsamples.component.css"],
})
export class LoggedsamplesComponent implements OnInit {
  apiUrl: string;
  searchAppointmentForm: FormGroup;
  uploadResultForm: FormGroup;
  bulkUploadResultForm: FormGroup;
  searchForm: FormGroup;
  loggedSamples: any = {};

  status: boolean = false;
  dtOptions: any = {};
  submitted = false;

  config: any;
  currentPageLength: any = 10;
  searchObject: any = {};

  sampleSingleResponse: any;
  fileUploaded: File;
  storedData: any;
  csvData: any;
  worksheet: any;

  daterange: any = {};

  options: any = {
    locale: { format: "YYYY-MM-DD" },
    alwaysShowCalendars: false,
  };

  uploadSampleFileTemplate: any;
  minDate: any = "";
  maxDate: any = "";

  // Bulk Upload
  files: any;
  file: any;
  isResponse = 0;
  isError = 0;
  isMessage = "";
  roleID: any;
  sample_file: any;
  filePath: any;
  columnError: string[] = [];
  error: any;
  isValidationError: any = false;
  //End Bulk Upload

  applicationId: any;
  private_laboratory_appId: any;
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private sess: SessionService,
    private spinnerService: Ng4LoadingSpinnerService,
    public shared: SharedService
  ) {}

  ngOnInit(searchObj = null) {
    this.sess.checkLogin();

    this.applicationId = localStorage.getItem("application_id");
    this.private_laboratory_appId = environment.APP_ID_PRIVATE_LABORATORY;
    this.sess.confirmUser(
      this.applicationId,
      this.private_laboratory_appId,
      "Private Laboratory"
    );

    this.uploadSampleFileTemplate =
      environment.APP_PUBLIC_URL + "files/Covid-Lab-Result-Sample.xlsx";

    if (searchObj == null || searchObj == "") {
      this.loggedSamples = "";
      this.initialiseForm();
      this.initTable();
      console.log("searchObj is null");
    } else {
      this.loggedSamples = "";
      console.log("searchObj is not null");
    }

    /* Pagination Start */
    this.config = {
      currentPage: 1,
      itemsPerPage: 10,
    };

    this.getLoggedSamples(this.config.itemsPerPage, this.config.currentPage);

    this.route.queryParams.subscribe(
      (params) =>
        (this.config.currentPage = params["page"] ? params["page"] : 1)
    );
    this.shared.getTravelTypes();
  }

  initialiseForm() {
    this.searchAppointmentForm = this.formBuilder.group({
      appointment_id: ["", [Validators.required]],
    });

    this.uploadResultForm = this.formBuilder.group({
      result: ["", [Validators.required]],
      // validity_date: ["", [Validators.required]],
      result_date: ["", [Validators.required]],
      appointmentId: [""],
      fullname: [""],
      phone: [""],
      passportNumber: [""],
      date: [""],
    });

    this.bulkUploadResultForm = this.formBuilder.group({
      // results: ["", [Validators.required]],
      myfile: ["", [Validators.required]],
    });

    this.searchForm = this.formBuilder.group({
      traveller_type: [""],
      daterangeInput: [""],
      payment_status: [""],
    });
  }

  initTable() {
    this.dtOptions = {
      paging: false,
      pagingType: "full_numbers",
      responsive: true,
      pageLength: 10,
      lengthChange: false,
      processing: false,
      ordering: false,
      info: false,
      columnDefs: [
        {
          //targets: [ 10 ],
          visible: false,
          searchable: false,
        },
      ],
      dom:
        "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        // { extend: 'csv',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-csv"> CSV</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'excel', className: 'btn btn-outline-dark', text: '<i class="fas fa-file-excel"> Excel</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} },
        // { extend: 'pdf',   className: 'btn btn-outline-dark', text: '<i class="fas fa-file-pdf"> PDF</i>' , orientation: 'landscape', pageSize: 'LEGAL', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}},
        // { extend: 'print', className: 'btn btn-outline-dark', text: '<i class="far fas fa-print"> Print</i>', exportOptions: {columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] } }
      ],
    };
  }

  onSearchAppointment(formData) {
    this.submitted = true;

    if (this.searchAppointmentForm.invalid) {
      return;
    }

    var requestObj = {};

    this.apiUrl =
      environment.AUTHAPIURL + "passenger-sample/" + formData.appointment_id;

    this.spinnerService.show();

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, requestObj, { headers: reqHeader })
      .subscribe((data) => {
        console.log("apiResponse: ", data);
        this.spinnerService.hide();

        if (data.status == true) {
          this.sampleSingleResponse = data.response;

          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });

          // this.ngOnInit();
          // this.utility.closeAllModals();
          $("#viewUploadResultModal").trigger("click");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            // text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
  }

  showUploadResult(sample, modal) {
    this.submitted = false;

    var requestObj = {};

    this.apiUrl =
      environment.AUTHAPIURL + "passenger-sample/" + sample.ctms_passenger_id;

    this.spinnerService.show();

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, requestObj, { headers: reqHeader })
      .subscribe((data) => {
        console.log("apiResponse: ", data);
        this.spinnerService.hide();

        if (data.status == true) {
          this.sampleSingleResponse = data.response;

          this.maxDate = new Date().toISOString().substring(0, 10);

          // this.minDate = this.sampleSingleResponse["result_date"]
          //   ? this.sampleSingleResponse["result_date"].split(" ")[0]
          //   : null;

          this.initSingleResultUpload(this.sampleSingleResponse);
          this.showModal(modal);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });
        }
      });
  }

  initSingleResultUpload(sample) {
    this.uploadResultForm = this.formBuilder.group({
      result: ["", [Validators.required]],
      // validity_date: ["", [Validators.required]],
      result_date: ["", [Validators.required]],

      appointmentId: [sample.ctms_passenger_id],
      fullname: [
        `${sample.first_name} ${sample.middle_name} ${sample.last_name}`,
      ],
      phone: [sample.phone],
      passportNumber: [sample.passport_no],
      // traveller: [sample.type == 1 ? 'DEPARTING' : 'ARRIVING'],
      date: [`${sample.booking_date} ${sample.booking_time}`],
    });
  }

  onUploadResult(formData) {
    // if (!this.fileUploaded) {
    //   Swal.fire({
    //     icon: "info",
    //     title: "Oops...",
    //     text: "Please upload result file",
    //     showConfirmButton: true,
    //     timer: 5000,
    //     timerProgressBar: true,
    //   });
    // }

    this.submitted = true;

    if (this.uploadResultForm.invalid) {
      return;
    }

    if (
      !confirm(
        "This action cannot be reverted, Kindly validate the information you have filled in. Do you want to proceed?"
      )
    )
      return;

    this.spinnerService.show();

    const reqHeader = new HttpHeaders({
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    var requestObj = {
      appointment_id: this.uploadResultForm.controls["appointmentId"].value,
      // result_date: this.uploadResultForm.controls["date"].value.split(" ")[0],
      status: formData.result,
      // validity_date: formData.validity_date,
      result_date: formData.result_date,
    };
    console.log(requestObj);
    this.apiUrl = environment.AUTHAPIURL + "lab-results/add";

    this.http
      .post<any>(this.apiUrl, requestObj, { headers: reqHeader })
      .subscribe((data) => {
        console.log(data);
        this.spinnerService.hide();

        if (data.status == true) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
          });

          // $("#viewStatusModal").trigger("click");
          this.ngOnInit();
          this.utility.closeAllModals();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: this.shared.getErrorMessage(data),
            // text: errorMessage, //data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  handleFileUpload(profileImageInput: any) {
    this.fileUploaded = profileImageInput.files[0];
    // console.log(this.fileUploaded);
    this.readExcel();
  }

  readExcel() {
    let readFile = new FileReader();
    readFile.onload = (e) => {
      this.storedData = readFile.result;
      var data = new Uint8Array(this.storedData);
      var arr = new Array();

      for (var i = 0; i != data.length; i++) {
        arr[i] = String.fromCharCode(data[i]);
      }

      var bstr = arr.join(" ");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      this.worksheet = workbook.Sheets[first_sheet_name];
    };

    readFile.readAsArrayBuffer(this.fileUploaded);
  }

  readAsCSV() {
    this.csvData = XLSX.utils.sheet_to_csv(this.worksheet);
    const data: Blob = new Blob([this.csvData], {
      type: "text/csv; charset=utf-8;",
    });
    FileSaver.saveAs(data, "CSVFile" + new Date().getTime() + ".csv");
  }

  showModal(modal) {
    this.utility.showModal(modal);
  }

  showBulkUploadResultModal(modal) {
    this.submitted = false;
    this.utility.modalOptions = {
      backdrop: true,
      centered: true,
      backdropClass: "customBackdrop",
      size: "lg",
    };
    this.showModal(modal);

    setTimeout(() => {
      this.utility.modalOptions = {
        backdrop: true,
        centered: true,
        backdropClass: "customBackdrop",
        size: "xl",
      };
    }, 1000);
  }

  nextPassenger() {
    this.utility.closeAllModals();
    $("#viewSearchAppointmentModal").trigger("click");
  }

  getLoggedSamples(perpage, pageno) {
    this.spinnerService.show();

    this.apiUrl =
      `${environment.AUTHAPIURL}sample-collection/list?page=` + pageno;

    this.searchObject["page_no"] = pageno;
    this.searchObject["per_page"] = perpage;
    this.searchObject["application_id"] =
      localStorage.getItem("application_id");
    this.searchObject["role_id"] = localStorage.getItem("role_id");

    const reqHeader = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    });

    this.http
      .post<any>(this.apiUrl, this.searchObject, { headers: reqHeader })
      .subscribe((data) => {
        this.spinnerService.hide();
        if (data.status == true) {
          console.log(data);
          this.loggedSamples = data.response.data;
          this.config.totalItems = data.response.total;
        } else {
          Swal.fire({
            icon: "info",
            title: "Oops...",
            text: data.message,
            showConfirmButton: true,
            timer: 5000,
            timerProgressBar: true,
          });
        }
      });
  }

  pageChange(newPage: number) {
    this.loggedSamples = "";
    this.router.navigate(["/loggedsamples"], {
      queryParams: { page: newPage },
    });
    this.getLoggedSamples(this.config.itemsPerPage, newPage);
  }

  public setItemsPerPage(event) {
    this.config.itemsPerPage = event;
    this.currentPageLength = this.config.itemsPerPage;
    this.loggedSamples = "";
    this.router.navigate(["/loggedsamples"]);
    this.getLoggedSamples(this.config.itemsPerPage, 1);
  }

  onSubmitSearch(formAllData: any) {
    this.submitted = true;

    // stop the process here if form is invalid
    if (this.searchForm.invalid) {
      return;
    }

    this.searchObject = {
      travel_type: formAllData.traveller_type,
      date_start: this.daterange.start ?? null,
      date_end: this.daterange.end ?? this.daterange.end,
      payment_status: "", //formAllData.payment_status,
    };

    console.log("searchFormData: ", this.searchObject);
    this.loggedSamples = "";
    this.getLoggedSamples(this.config.itemsPerPage, this.config.currentPage);
  }

  clearSearch() {
    this.loggedSamples = "";
    this.searchObject = {};
    this.initialiseForm();
    this.getLoggedSamples(this.config.itemsPerPage, this.config.currentPage);
  }

  selectedDate(value: any, datepicker?: any) {
    // this is the date  selected
    console.log("selectedDate: ", value);

    // any object can be passed to the selected event and it will be passed back here
    // datepicker.start = value.start;
    // datepicker.end = value.end;

    // use passed valuable to update state
    this.daterange.start = value.start.format("YYYY-MM-DD");
    this.daterange.end = value.end.format("YYYY-MM-DD");
    this.daterange.label = value.label;
  }

  // Bulk Upload
  onBulkUploadResult() {
    this.submitted = true;
    if (this.bulkUploadResultForm.invalid) {
      this.isValidationError = true;
      return;
    }
    // tslint:disable-next-line: max-line-length
    // In Angular 2+, it is very important to leave the Content-Type empty. If you set the 'Content-Type' to 'multipart/form-data' the upload will not work !
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    };

    const formData = new FormData();
    formData.append(
      "result_template",
      this.bulkUploadResultForm.get("myfile").value
    );
    this.apiUrl = environment.AUTHAPIURL;
    this.spinnerService.show();

    this.http
      .post<any>(this.apiUrl + "lab-results/import", formData, config)
      .subscribe((res) => {
        console.log(res);

        this.bulkUploadResultForm.reset();
        Object.keys(this.bulkUploadResultForm.controls).forEach((key) => {
          this.bulkUploadResultForm.get(key).setErrors(null);
        });
        if (res.status == true) {
          this.spinnerService.hide();

          this.bulkUploadResultForm.reset();
          Object.keys(this.bulkUploadResultForm.controls).forEach((key) => {
            this.bulkUploadResultForm.get(key).setErrors(null);
          });
          this.reload();
          if (res.message === "0 Results created; 0 updated.") {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Confirm the file content and try again.",
              showConfirmButton: true,
              timer: 5000,
              timerProgressBar: true,
            });
          } else {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
              timer: 5000,
              timerProgressBar: true,
            });
          }
        } else {
          this.spinnerService.hide();
          this.bulkUploadResultForm.reset();
          Object.keys(this.bulkUploadResultForm.controls).forEach((key) => {
            this.bulkUploadResultForm.get(key).setErrors(null);
          });
          const regex = /_/g;
          if (res.response == null) {
            this.reload();
            Swal.fire({
              icon: "warning",
              title: "Validation not passed",
              // html: '<div class="text-left ml-3 ">' + this.columnError.join('<br />') + '</div>' ,
              text: "The content of this file does not match the template provided",
              showConfirmButton: true,
              timer: 10000,
              timerProgressBar: true,
            });
          }

          for (const key of Object.keys(res.response)) {
            const row = res.response[key];

            for (const error of row) {
              let err = key.replace(regex, " " + ":");
              this.error =
                err.toUpperCase() +
                " " +
                (key.replace(regex, " ") + ":", error);
              this.columnError.push(this.error);
              console.log(this.error);
            }
          }

          this.reload();
          if (this.columnError.length < 12) {
            Swal.fire({
              icon: "warning",
              title: res.message,
              html:
                '<div class="text-left ml-3 ">  ERROR: ' +
                this.columnError.join("<br /> ERROR: ") +
                "</div>",
              // text: this.columnError.join('\n'),
              showConfirmButton: true,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: res.message,
              html:
                '<div class="text-left ml-3 p-0 my-4 div-scroll-alert"> ERROR: ' +
                this.columnError.join("<br /> ERROR: ") +
                "</div>",
              // text: this.columnError.join('\n'),
              showConfirmButton: true,
            });
          }
        }
      });
  }
  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = "reload";
    this.router.navigate(["./"], { relativeTo: this.route });
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.file = event.target.files[0];
      this.filePath = event.target.files[0].name;
      this.bulkUploadResultForm.get("myfile").setValue(file);
    }
  }
  //End Bulk Upload
}
